import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { StatusType } from 'src/components/form/controlled-select/ControlledSelect';
import { Controller } from 'src/components/form/field-controller/Controller';
import { FormField } from 'src/components/form/form/FormField';
import Multiselect from 'src/components/form/multi-select';

import type { ScheduleFormFieldData } from './scheduleFormSchema';
import type { ScheduleTarget } from './scheduleTargets';
import { pickSelectedOptions } from './scheduleTargets';

type Props = {
  options: ScheduleTarget[];
  statusType: StatusType;
};

/** The objects the schedule's one activity type is performed against. */
export const TargetField: FC<Props> = ({ options, statusType }) => {
  const { t } = useTranslation(['common']);
  const { control } = useFormContext<ScheduleFormFieldData>();
  const { error } = control.getFieldState('Targets');

  return (
    <Controller
      name={'Targets'}
      control={control}
      render={({ field: { ref, onChange, onBlur, value } }) => (
        <FormField
          label={t('scheduler.fields.targets')}
          errorText={error?.message}
          stretch={true}
          testId={'schedule-targets'}
        >
          <Multiselect
            ref={ref}
            options={options}
            // `Multiselect` passes this straight through rather than deciding
            // for itself (see the comment in ../../../components/form/select),
            // and the schedulable-targets read is unbounded, so a register-scale
            // org renders one Option component per row without it.
            virtualScroll={options.length >= 500}
            statusType={statusType}
            selectedOptions={value}
            onBlur={onBlur}
            onChange={(e) => {
              onChange(pickSelectedOptions(options, e.detail.selectedOptions));
            }}
            placeholder={t('select')}
            empty={t('noMatchedFound')}
          />
        </FormField>
      )}
    />
  );
};
